import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiServices from "./apiservice";
// import { toast } from "react-toastify";
// import { config } from "../constant";
import Transactionapiservices from "./transactionapiservices";

const initialState = {
  accessToken: "",
  isloading: false,
  iserror: false,
  transhistory:[],
  isSuccess: false,
  modelby: [],
  billing: [],
  payurl:{}
};

export const Paymentsession = createAsyncThunk(
  "pay/ment",
  async (user, { rejectWithValue }) => {
    // console.log("Paymentsession called with user:", user); 
    try {
      const response = await Transactionapiservices.Paymentapi(user);
      // console.log("Full API Response:", response); 
      return response; 
    } catch (err) {
      // console.error("Thunk Error in Paymentsession:", err); 
      return rejectWithValue(err); 
    }
  }
);



export const Transactionhistory = createAsyncThunk(
  "history/trans",
  async (user, { rejectWithValue }) => {
    try {
      const response = await Transactionapiservices.Transhistoryapi(user);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const Modelby = createAsyncThunk(
  "Model/by",
  async (user, { rejectWithValue }) => {
    try {
      const response = await Transactionapiservices.Modelbyapi(user);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const Billinginfo = createAsyncThunk(
  "billing/by",
  async (user, { rejectWithValue }) => {
    try {
      const response = await Transactionapiservices.Billinginfoapi(user);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const transactionSlice = createSlice({
  name: "transactions",
  initialState,
  reducers: {
    resettransaction: (state) => {
      state.accessToken = "";
    }
   
  },

  extraReducers: (builder) => {
    builder

      .addCase(Transactionhistory.pending, (state) => {
        state.isloading = true;
      })
      .addCase(Transactionhistory.fulfilled, (state, action) => {
        state.isloading = false;
        state.transhistory = action.payload
        state.isSuccess = true;
      })
      .addCase(Transactionhistory.rejected, (state) => {
        state.isloading = false;
        state.iserror = true;
      })
      .addCase(Modelby.pending, (state) => {
        state.isloading = true;
      })
      .addCase(Modelby.fulfilled, (state, action) => {
        state.isloading = false;
        state.modelby = action.payload
        state.isSuccess = true;
      })
      .addCase(Modelby.rejected, (state) => {
        state.isloading = false;
        state.iserror = true;
      })
      .addCase(Billinginfo.pending, (state) => {
        state.isloading = true;
      })
      .addCase(Billinginfo.fulfilled, (state, action) => {
        state.isloading = false;
        state.billing = action.payload
        state.isSuccess = true;
      })
      .addCase(Billinginfo.rejected, (state) => {
        state.isloading = false;
        state.iserror = true;
      })
      .addCase(Paymentsession.pending, (state) => {
        state.isloading = true;
      })
      .addCase(Paymentsession.fulfilled, (state, action) => {
        state.isloading = false;
        state.payurl = action.payload
        // console.log("Payment Session Payload:", action.payload); 
        // console.log(state.payurl, "Updated PayURL"); 
        state.isSuccess = true;
      })
      .addCase(Paymentsession.rejected, (state) => {
        state.isloading = false;
        state.iserror = true;
      });
  },
});

export const { resettransaction } = transactionSlice.actions;
export default transactionSlice.reducer;
